module.exports = __webpack_public_path__ + "static/img/btn.7acb1fdf.png";